import axios from "axios";
import { ElMessage, ElMessageBox } from "element-plus";
import store from "@/store";
import { getToken } from "@/utils/auth";
import router from "@/router";

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // baseURL: "http://realisticgames.zhiying2023.cn/estate/v1",
  timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["jwt"] = getToken();
    }
    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
// 响应拦截器
service.interceptors.response.use(
  (response) => {
    // 【核心修改点 1】判断是否是二进制流数据 (Blob 或 ArrayBuffer)
    // 如果是文件下载，直接返回整个 response.data，不做 code 校验
    if (response.data instanceof Blob || response.data instanceof ArrayBuffer) {
      return response.data;
    }

    const res = response.data;

    // 如果自定义的状态码不是 200，则判断为错误
    if (res.code !== 200) {
      ElMessage({
        message: res.msg || "Error",
        type: "error",
        duration: 3 * 1000,
      });

      if (res.code === 416) {
        router.replace("/");
      }

      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        ElMessageBox.alert("您已经注销，或重新登录", "通知", {
          confirmButtonText: "OK",
          callback: () => {
            store.dispatch("user/resetToken").then(() => {
              location.reload();
            });
          },
        });
      }
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    console.error("err" + error);
    ElMessage({
      message: error.message,
      type: "error",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);

export default service;
